import React from 'react'
import { withTranslation } from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import Button from '@material-ui/core/Button'

import classNames from 'classnames'
import ErrorCheckmark from '../ErrorCheckmark'

function failed({ type, labelButton, clickButton, message, t }) {
  const textMessage = message || t(type)
  return (
    <Card className="center p-1 container-sm mb-2 mt-2">
      <ErrorCheckmark
        className={classNames({ 'up-2': false })}
        style={{ width: '25%', maxWidth: '100px', margin: '0 auto' }}
      />
      <Typography variant="h6" className="pb-2">
        {textMessage}
      </Typography>
      {labelButton && clickButton && (
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="mt-2"
          id="failed-submit-waiver-button-retry"
          onClick={clickButton}
        >
          {t(labelButton)}
        </Button>
      )}
    </Card>
  )
}

export const Failed = withTranslation()(failed)
